import { QRCodeSVG } from "qrcode.react";
import { User } from "lucide-react";
import { fileHref } from "../common/MaterialUpload";

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }) : "-");

// CR80 portrait: 54 x 86 mm
export function IdCard({ s, validUntil, orgName = "Yutaka Learning Management System" }) {
  const valid = validUntil || s.batch_end_date;
  return (
    <div className="qr-card id-card relative overflow-hidden bg-white text-slate-900 rounded-xl border border-slate-300 flex flex-col" style={{ width: "54mm", height: "86mm" }} data-testid="id-card">
      <div className="bg-slate-950 text-white px-3 pt-2.5 pb-2 flex items-center gap-2">
        <img src="/logo-yumanabu.jpg" alt="" className="h-7 w-7 rounded bg-white object-contain p-0.5" />
        <div className="leading-tight"><p className="font-heading font-bold text-[11px] tracking-wide">YLMS</p><p className="text-[6.5px] uppercase tracking-wider text-slate-300">{orgName}</p></div>
      </div>
      <div className="h-1 bg-amber-400" />
      <div className="flex flex-col items-center px-3 pt-3 flex-1">
        <div className="h-[24mm] w-[20mm] rounded-md border border-slate-300 bg-slate-100 overflow-hidden grid place-items-center" data-testid="id-card-photo">
          {s.photo_url ? <img src={fileHref(s.photo_url)} alt={s.name} className="h-full w-full object-cover" /> : <User className="h-10 w-10 text-slate-300" />}
        </div>
        <p className="mt-2 font-heading font-bold text-[12px] leading-tight text-center" data-testid="id-card-name">{s.name}</p>
        <p className="text-[8px] font-mono text-slate-500">NIK {s.nik}</p>
        <div className="mt-1.5 grid grid-cols-2 gap-x-2 w-full text-[7.5px]">
          <div><p className="text-slate-400 uppercase tracking-wider text-[6px]">Angkatan</p><p className="font-semibold">{s.batch_name || "-"}</p></div>
          <div><p className="text-slate-400 uppercase tracking-wider text-[6px]">Kelas</p><p className="font-semibold">{s.stage || "PCL"}</p></div>
          <div className="col-span-2 mt-0.5"><p className="text-slate-400 uppercase tracking-wider text-[6px]">Berlaku s/d</p><p className="font-semibold" data-testid="id-card-valid">{fmtDate(valid)}</p></div>
        </div>
      </div>
      <div className="flex items-end justify-between px-3 pb-2.5">
        <div className="text-[6.5px] text-slate-400 leading-tight"><p>Kartu Identitas Siswa</p><p className="font-mono text-slate-600">{s.qr_id}</p></div>
        <QRCodeSVG value={s.qr_id} size={64} level="M" />
      </div>
    </div>
  );
}
